import * as React from 'react';
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ error });
    }
    render() {
        if (this.state.error) {
            return (React.createElement("div", { className: "contact-us-form__error-content" },
                React.createElement("h2", null, "Something went wrong. Please try again later.")));
        }
        return this.props.children;
    }
}
